import { useMutation } from "@apollo/client";

import { gql } from "~/__generated__";
import useRequireCurrentClient from "~/modules/client/hooks/useRequireCurrentClient";

import { downloadBase64EncodedCsv } from "../util/downloadBase64EncodedCsv";

const INVOICE_EXPORT_TO_CSV_MUTATION = gql(`
    mutation InvoiceExportToCsv($input: GqlInvoiceExportToCsvInput!) {
        invoiceExportToCsv(input: $input) {
            filename
            buffer
        }
    }
`);

export function useInvoiceCsvForPeriod() {
    const { client } = useRequireCurrentClient();

    const [createCsvAsync, { loading, error }] = useMutation(INVOICE_EXPORT_TO_CSV_MUTATION);

    const downloadCsv = async (invoiceId: string) => {
        const result = await createCsvAsync({
            variables: { input: { clientId: client.id, invoiceId } },
        });

        if (result.data === undefined || result.data === null) {
            return;
        }

        downloadBase64EncodedCsv(result.data.invoiceExportToCsv.buffer);
    };

    return { downloadCsv, loading, error };
}
